export default {
    // 报警订阅分组信息查询接口
    getAlarmSubscribeGroup(params, response) {
        window.vue.$apiAxios.postRequestBody('/alarmserver/alarm/getAlarmSubscribeGroup', params, response);
    },
    // 报警订阅分组信息添加接口
    saveAlarmSubscribeGroup(params, response) {
        if (params.isAddData) {
            window.vue.$apiAxios.postRequestBody('/alarmserver/alarm/addAlarmSubscribeGroup', JSON.stringify(params), response);
        } else {
            window.vue.$apiAxios.postRequestBody('/alarmserver/alarm/updateAlarmSubscribeGroup', JSON.stringify(params), response);
        }
    },
    // 报警订阅分组信息删除接口
    deleteAlarmSubscribeGroup(params, response) {
        window.vue.$apiAxios.postRequestBody('/alarmserver/alarm/deleteAlarmSubscribeGroup', params, response);
    },
    // 报警级别信息查询接口
    getAlarmLevel(params, response) {
        window.vue.$apiAxios.postRequestBody('/alarmserver/alarm/getAlarmLevel', params, response);
    },
    // 获取设备类型下拉列表
    getDeviceTypeList(params, response) {
        window.vue.$apiAxios.get('/alarmserver/alarm/getDeviceTypeList', params, response);
    },
    // 获取报警类型下拉树
    getAlarmTypeTree(params, response) {
        window.vue.$apiAxios.get('/alarmserver/alarm/getAlarmTypeTree', params, response);
    },
    // 根据设备类型查询报警事件
    getEventByDeviceType(params, response) {
        window.vue.$apiAxios.postRequestBody('/alarmserver/alarm/getEventByDeviceType', params, response);
    },
    // 查询树形
    findDeviceTree(params, response) {
        window.vue.$apiAxios.postRequestBody('/device/queryDeviceOrgTree', params, response);
    },
    // 搜索设备
    queryDeviceOrgTreeByName(params, response) {
        window.vue.$apiAxios.postRequestBody('/device/queryDeviceOrgTreeByName', params, response);
    },
    // 校验编号/名称是否重复
    checkRepeat(params, response) {
        window.vue.$apiAxios.postRequestBody('/alarmserver/alarm/checkAlarmGroupRepeat', JSON.stringify(params), response);
    },
    getAlarmEvent(params, response) {
        window.vue.$apiAxios.postRequestBody('/alarmserver/alarm/getAlarmEvent', JSON.stringify(params), response);
    },
    //根据设备id查询设备信息
    queryDeviceInfoByIds(params, response) {
        window.vue.$apiAxios.postRequestBody('/device/queryDeviceInfoByIds', JSON.stringify(params), response);
    },
    queryDeviceOrgInfoById(params, response) {
        window.vue.$apiAxios.postRequestBody('/device/queryDeviceOrgInfoById', JSON.stringify(params), response);
    }
};
